import { motion } from "framer-motion";
import { TRAINING } from "../../data/content";

export const Training = () => {
  return (
    <section id="training" data-testid="training-section" className="relative py-24 lg:py-32 bg-[#F8FAFC]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-[2px] w-10 bg-[#F5B800]" />
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1C9FD8]">Training Programs</p>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-slate-900">
              Hands-on curriculum, industry depth.
            </h2>
            <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed">
              Structured programs for freshers and laterals — from language fundamentals to bare-metal ARM,
              Linux, and hardware platforms. Every track pairs technical mastery with communication skills.
            </p>
            <div className="mt-10 border border-slate-200 overflow-hidden">
              <img
                src="https://images.pexels.com/photos/7793750/pexels-photo-7793750.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Engineering training session"
                className="w-full h-56 object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="border-t border-slate-200">
              {TRAINING.map((t, i) => (
                <motion.div
                  key={t.title}
                  data-testid="training-program-card"
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                  className="group flex items-baseline gap-6 py-6 border-b border-slate-200 hover:pl-2 transition-all"
                >
                  <span className="font-display text-sm font-bold text-slate-300 w-8 shrink-0">/{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#1C9FD8] mb-1">{t.category}</p>
                    <h3 className="font-display text-lg lg:text-xl font-semibold tracking-tight text-slate-900 group-hover:text-[#1E4D8B] transition-colors">
                      {t.title}
                    </h3>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
